export const Svg_100 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M18.156 61.25a2.72 2.72 0 0 1-1.677-.546c-.486-.365-.73-.839-.73-1.422v-6.125a7.038 7.038 0 0 1-3.098-3.354 11.241 11.241 0 0 1-.985-4.667V16.188c0-3.597 1.86-6.222 5.578-7.875 3.72-1.653 9.662-2.48 17.828-2.48 8.07 0 13.964.827 17.683 2.48 3.718 1.653 5.578 4.278 5.578 7.875v28.948a11.24 11.24 0 0 1-.984 4.666 7.037 7.037 0 0 1-3.1 3.355v6.125c0 .583-.242 1.057-.729 1.422a2.72 2.72 0 0 1-1.677.547h-1.385c-.68 0-1.264-.183-1.75-.547-.486-.365-.73-.839-.73-1.422v-4.01H22.02v4.01c0 .583-.243 1.057-.729 1.422-.486.364-1.07.547-1.75.547h-1.385Zm16.916-46.958h18.886H16.04h19.031ZM47.98 35.657H16.04h37.917-5.98ZM16.04 31.282h37.917V18.667H16.04v12.615Zm7.73 15.969c1.117 0 2.065-.39 2.843-1.167.778-.778 1.167-1.726 1.167-2.844 0-1.118-.389-2.066-1.167-2.844s-1.726-1.166-2.844-1.166c-1.118 0-2.066.389-2.843 1.166-.778.778-1.167 1.726-1.167 2.844 0 1.118.389 2.066 1.167 2.844.777.778 1.725 1.166 2.843 1.166Zm22.458 0c1.118 0 2.066-.39 2.843-1.167.778-.778 1.167-1.726 1.167-2.844 0-1.118-.389-2.066-1.166-2.844-.778-.778-1.726-1.166-2.844-1.166-1.118 0-2.066.389-2.844 1.166-.778.778-1.167 1.726-1.167 2.844 0 1.118.39 2.066 1.167 2.844.778.778 1.726 1.166 2.844 1.166ZM16.04 14.291h37.917c-1.167-1.264-3.403-2.26-6.708-2.99-3.306-.729-7.365-1.093-12.178-1.093-5.736 0-10.135.328-13.197.984-3.063.656-5.007 1.69-5.834 3.1Zm5.98 36.604h25.958c1.701 0 3.123-.656 4.265-1.968 1.143-1.313 1.714-2.82 1.714-4.521v-8.75H16.04v8.75c0 1.701.571 3.208 1.714 4.52 1.142 1.313 2.564 1.97 4.265 1.97Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={50.535}
        y1={14.146}
        y2={52.411}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)